import React from 'react';
import ProspectDetail from '../components/partner-network/ProspectDetail';

const PartnerProspectDetailPage: React.FC = () => <ProspectDetail />;

export default PartnerProspectDetailPage;
